import { useNavigation } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";
import { useContext } from "react";
import {
  View,
  StyleSheet,
  Platform,
  SafeAreaView,
  StatusBar,
  TouchableOpacity,
  Image,
  Text,
} from "react-native";
import { Colors } from "react-native/Libraries/NewAppScreen";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppImages } from "../utility/AppImages";
import { ThemeContext } from "../context/ThemeContext";
import { AppColors } from "../utility/AppColors";
import { s } from "react-native-size-matters";
import React from "react";

export const ScreenBGGradientView = () => {
  return (
    <LinearGradient
      colors={[AppColors.sidebarBackground_111827, AppColors.black]}
      start={[0, 0]}
      end={[0, 1]}
      style={styles.background}
    />
  );
};

export default function TabHeaderView(props: any) {
  const navigation = useNavigation();
  const {
    headerViewStyle,
    title = "",
    titleTextStyle,
    onBackPress = () => {},
    isBackVisible = false,
    isRightIconShow = false,
    rightIcon,
    rightIconPress = () => {},
    isRightTextShow = false,
    rightText,
    rightTextPress = () => {},
  } = props;

  return (
    <SafeAreaView
      style={{
        paddingTop: Platform.OS === "android" ? StatusBar.currentHeight + 5 : 0,
      }}
    >
      <View style={[styles.headerStyle, headerViewStyle]}>
        <TouchableOpacity activeOpacity={0.5} onPress={onBackPress}>
          <View style={{ flexDirection: "row", gap: 8, alignItems: "center" }}>
            {isBackVisible ? (
              <Image source={AppImages.icIconBack} style={styles.backButton} />
            ) : null}
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_20,
                {
                  alignSelf: "center",
                  color: AppColors.black,
                },
                titleTextStyle,
              ]}
            >
              {title}
            </Text>
          </View>
        </TouchableOpacity>
        {!isRightIconShow ? null : (
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => {
              rightIconPress();
            }}
          >
            <View>
              {rightIcon !== null ? (
                <Image
                  source={rightIcon}
                  style={{ width: 40, height: 40, right: 15 }}
                  resizeMode="contain"
                />
              ) : null}
            </View>
          </TouchableOpacity>
        )}
        {!isRightTextShow ? null : (
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => {
              rightTextPress();
            }}
          >
            <View>
              {rightText !== null ? (
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { height: 40, color: "white", textAlign: "right" },
                  ]}
                >
                  {rightText}
                </Text>
              ) : null}
            </View>
          </TouchableOpacity>
        )}
      </View>
    </SafeAreaView>
  );
}

export const ButtonLeftImageWithBGImage = (props: any) => {
  const {
    btnImage = AppImages.icApple,
    btnStyle = {},
    isShowBgImage = false,
    btnBGImage,
    textStyle = {},
    btnTitle = "Sign In with Apple",
    onPress = () => {
      String;
    },
  } = props;
  return (
    <TouchableOpacity
      style={[
        {
          height: s(50),
          backgroundColor: AppColors.black,
          borderRadius: s(30),
          justifyContent: "center",
          shadowColor: AppColors.white,
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.3,
          shadowRadius: s(7),
          elevation: s(10),
        },
        btnStyle,
      ]}
      activeOpacity={0.8}
      onPress={() => {
        onPress(btnTitle);
      }}
    >
      {isShowBgImage ? (
        <Image
          source={AppImages.icInstagramBG}
          resizeMode="stretch"
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
          }}
        />
      ) : null}

      <Image
        source={btnImage}
        style={{
          width: s(22),
          height: s(22),
          alignContent: "flex-start",
          marginStart: s(28),
        }}
      />
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            position: "absolute",
            alignSelf: "center",
          },
          textStyle,
        ]}
      >
        {btnTitle}
      </Text>
    </TouchableOpacity>
  );
};

export const SeparaterView = (props: any) => {
  const { style = {} } = props;
  return (
    <View
      style={[
        {
          height: 2,
          backgroundColor: AppColors.appGrayColor_1C1C1C,
          // flex: 2
        },
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  background: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    height: "100%",
    zIndex: -1,
  },
  headerStyle: {
    flexDirection: "row",
    paddingHorizontal: s(20),
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  backButton: {
    height: 40,
    width: 40,
    resizeMode: "contain",
    // tintColor: AppColors.black
  },
});
